/*
 * Author: Dw
 * File Created: Monday, 24-08-05 02:04 pm
 * Last Modified: Wednesday, 24-11-27 03:08 pm, by Harper Yan
 */

import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import SectionBox from '../SectionBox';
import FooterBottom from './FooterBottom';
import MobileFooter from './MobileFooter';
import PcFooter from './PcFooter';
interface FooterProps {
  vip: boolean;
}
const Footer: React.FC<FooterProps> = ({
  vip: isVip
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  return <SectionBox disableGutters={false} layerSx={{
    background: '#1C1C1C'
  }} sx={{
    pt: ['40px', '60px']
  }} data-sentry-element="SectionBox" data-sentry-component="Footer" data-sentry-source-file="index.tsx">
      {isXs ? <MobileFooter vip={isVip} /> : <PcFooter vip={isVip} />}
      <FooterBottom isXs={isXs} data-sentry-element="FooterBottom" data-sentry-source-file="index.tsx" />
    </SectionBox>;
};
export default Footer;